<template>
  <div
    v-if="pageLoading"
    class="m-3"
  >
    <placeholder-content :is-load="true" />
  </div>
  <div
    v-else-if="!hasPermission"
    class="m-3"
  >
    <access-denied />
  </div>
  <div v-else>
    <div class="m-3 mb-0">
      <h5 class="mb-1">{{ $t('Settings') }}</h5>
      <p class="text-muted mb-0" style="font-size: 13px;">
        {{ $t('System settings.') }}
      </p>
    </div>

    <!-- แพ็กของร้าน — ดูอย่างเดียว ต่ออายุทาง LINE (docs/plans-app.md) -->
    <plan-settings-card />

    <!-- ภาษี / การจด VAT — เป็นของนิติบุคคล ไม่ใช่ของสาขา (api/docs/vat-compliance.md §2) -->
    <tax-settings-card
      :tax="settings.tax"
      @edit="offcanvasTaxForm.open = true"
    />

    <!-- เครื่องพิมพ์ของ "เครื่องนี้" — ค่าอยู่ในเบราว์เซอร์ ไม่ใช่ของร้าน (utils/printerSettings.js) -->
    <printer-settings-card />

    <!-- การ์ดของฟีเจอร์ที่ผูกแพ็ก — แพ็กไม่มีก็ซ่อน (สวิตช์เปิด/ปิดของเจ้าของร้านยังเก็บค่าเดิมไว้ อัปเกรดกลับมาเหมือนเดิม) -->
    <!-- Loyalty section -->
    <loyalty-settings-card
      v-if="$hasFeature('feature_loyalty')"
      :initial-enabled="settings.loyalty_is_enabled"
    />

    <!-- Promotion section -->
    <promotion-settings-card
      v-if="$hasFeature('feature_promotions')"
      :initial-enabled="settings.promotion_is_enabled"
    />

    <!-- Product Categories (link ไปหน้าจัดการหมวดหมู่เมนู + จัดลำดับ) -->
    <product-categories-settings-card />

    <!-- KDS Stations -->
    <kds-stations-settings-card v-if="$hasFeature('feature_kds')" />

    <!-- Expense Categories (link ไปหน้าจัดการหมวดค่าใช้จ่าย) -->
    <expense-categories-settings-card v-if="$hasFeature('feature_expenses')" />

    <!-- Delivery Channels — toggle เปิด/ปิดระบบ + link ไปหน้าจัดการช่องทาง/price book -->
    <delivery-platforms-settings-card
      v-if="$hasFeature('feature_delivery_platforms')"
      :initial-enabled="settings.delivery_platform_is_enabled"
    />

    <!-- หัวข้อ setting อื่นในอนาคตเพิ่มเป็น card ที่นี่ -->

    <offcanvas-tax-form v-if="offcanvasTaxForm.open" />
  </div>
</template>

<script lang="js">
import { Setting } from '@/services/endpoint/setting.service';
import TaxSettingsCard from '@/components/settings/TaxSettingsCard.vue';
import PrinterSettingsCard from '@/components/settings/PrinterSettingsCard.vue';
import PlanSettingsCard from '@/components/settings/PlanSettingsCard.vue';
import OffcanvasTaxForm from '@/components/settings/OffcanvasTaxForm.vue';
import LoyaltySettingsCard from '@/components/loyalty/settings/SettingsCard.vue';
import PromotionSettingsCard from '@/components/promotions/SettingsCard.vue';
import KdsStationsSettingsCard from '@/components/kds-stations/SettingsCard.vue';
import ProductCategoriesSettingsCard from '@/components/product-categories/SettingsCard.vue';
import ExpenseCategoriesSettingsCard from '@/components/expense-categories/SettingsCard.vue';
import DeliveryPlatformsSettingsCard from '@/components/delivery-platforms/SettingsCard.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';

export default {
  name: 'Settings',
  components: { AccessDenied, PlaceholderContent, PlanSettingsCard, TaxSettingsCard, PrinterSettingsCard, OffcanvasTaxForm, LoyaltySettingsCard, PromotionSettingsCard, ProductCategoriesSettingsCard, KdsStationsSettingsCard, ExpenseCategoriesSettingsCard, DeliveryPlatformsSettingsCard },
  data() {
    return {
      pageLoading: true,
      hasPermission: true,
      offcanvasTaxForm: { open: false },
      settings: {
        loyalty_is_enabled: false,
        promotion_is_enabled: false,
        delivery_platform_is_enabled: false,
        tax: {}
      }
    };
  },
  methods: {
    // ยิง GET ครั้งเดียวที่หน้า แล้วส่งค่าเริ่มต้นให้แต่ละ card (card ไม่ต้อง fetch เอง)
    // offcanvas เรียกซ้ำหลังบันทึกเพื่อรีเฟรชสรุปบนการ์ด
    async fetchData() {
      try {
        const res = await Setting.get();
        const d = res.data?.data ?? res.data ?? {};
        this.settings.loyalty_is_enabled = !!d.loyalty_is_enabled;
        this.settings.promotion_is_enabled = !!d.promotion_is_enabled;
        this.settings.delivery_platform_is_enabled = !!d.delivery_platform_is_enabled;
        this.settings.tax = {
          tax_policy: d.tax_policy || 'no_tax',
          vat_rate: d.vat_rate ?? 0,
          tax_id: d.tax_id || '',
          tax_entity_name: d.tax_entity_name || '',
        };
      } catch (err) {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
        }
      }
    }
  },
  async mounted() {
    await this.fetchData();
    this.pageLoading = false;
  }
};
</script>
